import React, { useState } from 'react'
import './Balance.css'
import { FaRegEyeSlash } from "react-icons/fa6";
import { IoEyeOutline } from "react-icons/io5";

const Balance = ({ balance }) => {
    const [visible, setVisible] = useState(false);

    const toggleVisibility = () => {
        setVisible(!visible);
    }
  return (
    <div className='balance'>
        <div>Legacy Credits</div>
        <div className='view-balance'>
            <div>{visible ? balance : 'View Balance'}</div>
            <div onClick={toggleVisibility} className='toggle-visibility'>
                {visible ? <FaRegEyeSlash size={24}/> : <IoEyeOutline size={24}/>}
            </div>
        </div>
    </div>
  )
}

export default Balance